import { Controller } from "stimulus";
import ahoy from "ahoy.js"

export default class extends Controller {
  static targets = ["links"]

  connect() {
    this.userEmail = this.data.get("email")
  }

  onClick(e) {
    e.preventDefault()

    let url      = e.currentTarget.dataset.link
    let filename = e.currentTarget.dataset.filename
    ahoy.track('download_report', {email: this.userEmail, filename: filename})

    window.location = url
  }
}